import PropTypes from "prop-types";

import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const headerVariants = {
	hidden: { opacity: 0, y: 120 },
	visible: {
		opacity: 1,
		y: 0,
		transition: {
			duration: 0.5,
		},
	},
};

const SectionHeader = ({ title, subtitle, heading }) => {
	const headingH1 = heading ? "h1" : "h2";
	const [ref, inView] = useInView({
		triggerOnce: true,
		threshold: 0.1,
	});

	return (
		<motion.div
			ref={ref}
			initial="hidden"
			animate={inView ? "visible" : "hidden"}
			variants={headerVariants}
			className="flex flex-col justify-center items-center gap-4"
		>
			{headingH1 === "h1" ? (
				<h1 className="font-[600] text-4xl text-center text-steerBlack lg:xl:text-6xl dark:text-white">
					{title}
				</h1>
			) : (
				<h2 className="font-[600] text-4xl text-center text-steerBlack lg:xl:text-6xl dark:text-white">
					{title}
				</h2>
			)}

			<p className="lg:text-center font-light text-left lg:w-1/2 flex justify-center text-sm lg:text-base items-center">
				{subtitle}
			</p>
		</motion.div>
	);
};

SectionHeader.propTypes = {
	title: PropTypes.string.isRequired,
	subtitle: PropTypes.string.isRequired,
	heading: PropTypes.string,
};

export default SectionHeader;
